module.exports = __webpack_public_path__ + "img/icon-ekyc-detail-jumio.a9059b3.svg";